import PropTypes from 'prop-types'
import { useTemplateContext } from '@/context/TemplateProvider'
import CommonComponents from '@/components/templates/common'
import Layout from "./views";

const MaxFitHeader = ({ transparent = false }) => {
  const { template } = useTemplateContext()
  return (
    <Layout.Header 
      textColor="textPrimary"
      backgroundColor={transparent ? undefined : "complementary"}
    >
      <CommonComponents.Wrapper height="80px">
        <Layout.Logo>
          {template.logo.src ? (
            <Layout.LogoImage src={template.logo.src} />
          ) : (
            <Layout.LogoText fontFamily={template.logo.fontFamily}>
              {template.logo.text}
            </Layout.LogoText>
          )}
        </Layout.Logo>
      </CommonComponents.Wrapper>
      <Layout.Menu hasShoppingCart={template.sections.navigation.hasShoppingCart} />
    </Layout.Header>
  )
}

MaxFitHeader.propTypes = {
  transparent: PropTypes.bool,
}

export default MaxFitHeader
